import { ActivityLog } from "src/app/entities/ActivityLog";
import { TimeRecord } from "src/app/entities/timeRecord";
import { TimeRecordWithChildrenDto } from "./time-record-with-children-dto";

export class ActivityLogWithChildrenDto extends ActivityLog {
    TimeRecords: TimeRecordWithChildrenDto[];

    constructor(activityLog: ActivityLog, timeRecords: (TimeRecord | TimeRecordWithChildrenDto)[]) {
        super(activityLog);
        this.TimeRecords = timeRecords.map(timeRecord => timeRecord instanceof TimeRecordWithChildrenDto ? timeRecord : new TimeRecordWithChildrenDto(timeRecord, []));
    }
}